<template>
  <div>
    <div class=" row mb-2" >
      <label class="col-sm-4 lh40 text-lr"><i
          v-if=" Data.data.c_priority==='S'"
          class="fa fa-asterisk text-danger font10 ml-1"
          aria-hidden="true"></i>{{ Data.data.c_name }}：</label>
      <div class="col-sm-7 " v-for="(item,index) in temp_list" :key="index">
        <el-time-picker value-format="HH:mm:ss"
            v-model="item.value" @change="dealData"
            placeholder="任意时间点">
        </el-time-picker>
        <span style="margin-left: 5px">  <el-button type="text" @click="add_temp()">+</el-button>
         <el-button type="text" @click="min_temp(index)" v-if="temp_list.length>1">-</el-button></span>

      </div>
  </div>
  </div>

</template>

<script>
    export default {
        data() {
            return {
              value: this.Data.data.c_value,
              temp_list:[{'value':''}]

           }
        },

        created() {

        },
        name: "time_box",
        methods: {
          dealData(){
            var arry=[]
            for(let i in this.temp_list){
              arry.push(this.temp_list[i].value)
            }
            this.$get_function(this.Data,arry)

          },
          min_temp(index){
            this.temp_list.splice(index,1)
          },
          add_temp(){
            this.temp_list.push({'value':''})
          },

        },
    }
</script>

<style scoped>

</style>
